import React from 'react'
import PropTypes from 'prop-types'

import { Button, SvgIcon } from '@material-ui/core'
import { mdiPlus } from '@mdi/js'

class AddButton extends React.Component {
  static propTypes = {
    classes: PropTypes.string,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    classes: '',
  }

  render() {
    const { classes, label, onClick } = this.props

    return (
      <Button className={classes} variant="contained" aria-label={label} onClick={onClick}>
        <SvgIcon>
          <path d={mdiPlus} />
        </SvgIcon>
        {label}
      </Button>
    )
  }
}

export default AddButton
